import { useIntegratedActionBroadcaster } from '../../action-broadcaster/use-integrated-action-broadcaster';
import { useApiClient } from '~/api-client';
import { logout } from '~/session';
import { v4 } from 'uuid';
import { useCallback } from 'react';
import { useBroadcast } from '../../common/broadcast-channel/use-broadcast';
import { useApplicationType } from './use-application-type';
import { useBootstrapState } from '../../bootstrap/bootstrap-provider';

export function useLogout() {
    const bootstrapState = useBootstrapState();

    const { isElectron, isElectronRewrite } = useApplicationType();
    const { trigger } = useIntegratedActionBroadcaster();
    const { postMessage } = useBroadcast('legacy-store-broadcast');
    const apiClient = useApiClient();

    return useCallback(() => {
        if (isElectron) {
            if (isElectronRewrite) {
                trigger([
                    {
                        id: v4(),
                        targetWindowType: 'ROOT',
                        type: 'LOGOUT',
                    },
                ]);
            } else {
                postMessage({ type: 'LOGOUT' });
            }
        } else {
            logout(apiClient, bootstrapState.ssoV2LogoutUrl);
        }
    }, [trigger, postMessage, isElectron, isElectronRewrite, apiClient, bootstrapState]);
}
